import { app } from '../app'
import { createApp } from 'vue'
import { vuetify } from '../vuetify'
import { errorMixin } from '../mixins/error-mixin'
import { i18n } from '../i18n'
import VContactForm from '../components/VContactForm.vue'

createApp({
  extends: app,
  mixins: [errorMixin],
  components: {
    VContactForm
  },
})
  .use(vuetify)
  .use(i18n)
  .mount('#app')
